import { Component, OnInit } from '@angular/core';

import { AppService } from '../../../services/app.service';
import { NotificationService } from '../../../services/notification.service';
import { ITableColumn } from '../../../shared/table/table.component';
import { INotificationInboxListItem } from '../../../models/Notification';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { NotificationInboxViewComponent } from '../inbox-view/notification-inbox-view.component';

@Component({
    selector: 'app-notification-inbox',
    templateUrl: './notification-inbox.component.html'
})
export class NotificationInboxComponent implements OnInit {
    constructor(
        private app: AppService,
        private service: NotificationService,
        private modal: NgbModal
    ) { }

    items: INotificationInboxListItem[] = [];

    readonly columns: ITableColumn[] = [
        { label: 'notification_lblDate', type: 'date', sorts: true },
        { label: 'notification_lblType', sorts: true },
        { label: 'notification_lblSubject', sorts: true },
        { label: 'notification_lblMessage' },
        { width: '1px' }
    ];

    ngOnInit() {
        this.fetch();
    }

    open(item: INotificationInboxListItem) {
        const ref = this.modal.open(NotificationInboxViewComponent);
        ref.componentInstance.item = item;
    }

    getMessage(item: INotificationInboxListItem): string {
        let message = item.ShortMessage;

        if (!message) {
            const div = document.createElement('div');
            div.innerHTML = item.Message;

            message = div.textContent;

            if (message.length > 100) {
                message = message.substring(0, 100) + '...';
            }
        }

        return message;
    }

    private fetch() {
        this.app.addLoading(this.service.getInbox()).subscribe(data => {
            this.items = data;
        });
    }
}
